import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { securityAuthenticationForgotPasswordAsyncSlice } from './post';

export const securityAuthenticationForgotPasswordReducers = combineReducers({
	post: securityAuthenticationForgotPasswordAsyncSlice.asyncReducers
});

export const securityAuthenticationForgotPasswordWatchers = combineAllWatchers([
	securityAuthenticationForgotPasswordAsyncSlice.asyncWatchers
]);
